<template>
  <div class="page_backgroundCheck">
    <div class="memberTop">
      <div class="memberInput">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>小杰闪查</el-breadcrumb-item>
          <el-breadcrumb-item>闪查项目</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="dashboard">
        <div class="dashboard_item">
          <div class="dash_sel_box">
            <div class="flname">项目名称</div>
            <el-select ref="mySelected" v-model="listQuery.BusiId" filterable size="small" placeholder="" @change="proSearChange">
              <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dashboard_item">
          <div class="dashboard_item_title">余额 <span class="dashboard_item_content" style="color:#f59a23;">￥ {{remainingTimes}}</span> </div>
        </div>
        <div class="dashboard_item">
          <div class="dashboard_item_title">消费金额 <span class="dashboard_item_content">￥{{AmountSpent}}</span> </div>
        </div>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="闪查项目" name="first"></el-tab-pane>
          <el-tab-pane label="闪查报告" name="second"></el-tab-pane>
          <el-tab-pane label="闪查二维码" name="third"></el-tab-pane>
        </el-tabs>
        <!-- <div class="ftabs_title">闪查项目选择</div> -->

        <el-table :data="tableData" border style="width: 100%" :show-header="true">
          <el-table-column :key="checkedAll" prop="name" align="center" label="" width="180">
            <template slot="header">
              <el-checkbox v-model="checkedAll" style="margin-right: 10px;" @change="changeCheckAll" />
              <span class="th">全部选择</span>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="margin-right: 10px;" @change="changeCheck(scope.row)" />
              <span class="th">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="">
            <template slot-scope="scope">
              <div class="checkBox flex">
                <div v-for="(item,index) in scope.row.productList" :key="index" :class="index>2 ? 'checkItem cp mt' : 'checkItem cp'" @click="select(item,scope.row)">
                  <!-- <el-tooltip class="item" effect="dark" :content="item.tip" placement="top"> -->
                  <div style="width: 100%;" :class="item.selected ? 'selectedbc flex aic sb' : 'flex aic sb' ">
                    <!-- <img :src="item.selected ? item.icon1 : item.icon" alt="" class="icon"> -->
                    <el-tooltip class="item" effect="dark" :content="item.ProductDescri" placement="top">
                      <div style="padding-left: 15px;"> {{ item.Product }}</div>
                    </el-tooltip>
                    <div class="warningIcon" v-if="item.IsAuthorize == '1'"> <i class="el-icon-warning-outline" title="该项目需要候选人授权"></i></div>
                  </div>
                  <!-- </el-tooltip> -->
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="ftabs">
        <div class="ftabs_title">查询条件</div>
        <el-form ref="ruleForm" :model="form" :inline="true" :rules="rules">
          <el-form-item label="姓名" prop="name" label-width="80px">
            <el-input v-model.trim="form.name" style="width: 180px;" />
          </el-form-item>
          <el-form-item v-if="needIdcard" label="身份证号" prop="idcard" label-width="80px">
            <el-input v-model.trim="form.idcard" style="width: 180px;" />
          </el-form-item>
          <el-form-item v-if="needPhone" label="手机号" prop="tel" label-width="80px">
            <el-input v-model.trim="form.tel" style="width: 180px;" />
          </el-form-item>
          <el-form-item v-if="needBank" label="银行卡" prop="Bankcard" label-width="80px">
            <el-input v-model.trim="form.Bankcard" style="width: 180px;" />
          </el-form-item>
          <el-form-item v-if="needEntName" label="企业名称" prop="Entname" label-width="80px">
            <el-input v-model.trim="form.Entname" style="width: 180px;" />
          </el-form-item>
          <el-form-item v-if="needEnt" label="统一社会信用代码" prop="Entcode" label-width="160px">
            <el-input v-model.trim="form.Entcode" style="width: 180px;" />
          </el-form-item>
          <div class="flex sb" style="width:100%">
            <div>
              <el-button v-if="checkPermission(['backgroundCheck_query'],permissionLists)" v-preventReClick :loading="isBtnLoading" style="margin-left: 15px;" icon="el-icon-search" type="success" size="medium" @click="submitForm('ruleForm')">&nbsp;查&nbsp;&nbsp;&nbsp;&nbsp;询</el-button>
              <el-button v-if="checkPermission(['backgroundCheck_batch_query'],permissionLists)" type="primary" icon="el-icon-upload" size="medium" @click="batchHandle">&nbsp;批量查询</el-button>
              <el-button v-if="checkPermission(['backgroundCheck_batch_query'],permissionLists)" type="primary" icon="el-icon-upload" size="medium" @click="batchImpHandle">&nbsp;批量导入查询</el-button>
              <el-button size="medium" icon="el-icon-refresh" @click="resetForm('ruleForm')">&nbsp;重&nbsp;&nbsp;&nbsp;&nbsp;置</el-button>
              <el-button size="medium" icon="el-icon-plus" type="warning" @click="createQRcode">创建闪查二维码</el-button>
            </div>
            <div class="price">
              ￥{{ totalPrice }}
            </div>
          </div>
        </el-form>
      </div>

      <div v-if="hasCheck" class="ftabs" style="padding-bottom: 24px;">
        <div class="ftabs_title">查询结果</div>
        <div v-if="flagIsAuthorize==false && hasResult" style="overflow-x: auto;">
          <el-button v-if="checkPermission(['backgroundCheck_export'],permissionLists)" style="background-color: #18BE6A;margin-left: 15px;color: #Fff;margin-bottom: 16px;" icon="el-icon-document" @click="handleExport">导出报告</el-button>
          <!-- <div class="contentTips">将身份证持有者的姓名、证件号码与官方数据库的信息进行比对，核验信息是否一致。</div> -->
          <div class="mb24" v-for="(item,index) in result.orderDetailList" :key="index">
            <!-- 身份风险查询 -->
            <div v-if="item.Category == '身份风险'">
              <div v-if="(item.Sort == 1)&&(!isNull(identityReport)||!isNull(telReport)||!isNull(bankReport))" class="category_title category_title00"> {{item.Category}}查询</div>
              <div v-if="(item.ProductId == 'f11ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(identityReport)" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <!-- <div class="bg_result_box bg_result_box00">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right bg_widthauto">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                <el-table :data="identityReport" border>
                  <el-table-column prop="name" align="center" label="查询内容" />
                  <el-table-column prop="result" align="center" label="查询结果" />
                  <el-table-column prop="truth" align="center" label="真实性">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" />
                </el-table>
              </div>
              <!-- 身份,手机号验证 -->
              <div v-if="(item.ProductId == 'f21ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(telReport)" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <!-- <div class="bg_result_box bg_result_box00">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right bg_widthauto">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                <el-table :data="telReport" border>
                  <el-table-column prop="name" align="center" label="查询内容" />
                  <el-table-column prop="result" align="center" label="查询结果" />
                  <el-table-column prop="truth" align="center" label="真实性">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" />
                </el-table>
              </div>
              <!-- 身份,银行卡,手机号验证 -->
              <div v-if="(item.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(bankReport)">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <!-- <div class="bg_result_box bg_result_box00">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right bg_widthauto">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                <el-table :data="bankReport" border>
                  <el-table-column prop="name" align="center" label="查询内容" />
                  <el-table-column prop="result" align="center" label="查询结果" />
                  <el-table-column prop="truth" align="center" label="真实性">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" />
                </el-table>
              </div>
            </div>
            <div v-if="item.Category == '不良风险'" class="mb24">
              <div v-if="item.Sort == 1" class="category_title category_title00"> {{item.Category}}查询</div>
              <div class="bg_des_box">
                <div class="bg_des_left">{{ item.Product }}</div>
                <div class="bg_des_right">{{ item.ProductDescri }}</div>
              </div>
              <div class="bg_result_box bg_result_box00">
                <div class="bg_result_item">
                  <div class="bg_result_cell bg_result_left">查询结果</div>
                  <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                </div>
                <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                  <div class="bg_result_cell bg_result_left">不良行为记录</div>
                  <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultDetailStr }}</div>
                </div>
              </div>
            </div>
            <div v-if="item.Category == '诉讼风险'">
              <div v-if="item.Sort == 1" class="category_title category_title00"> {{item.Category}}查询</div>
              <!-- 司法诉讼 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b9c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">
                      <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>0))?item.ResultStr.split('|')[0]:'' }}</p>
                      <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>1))?item.ResultStr.split('|')[1]:'' }}</p>
                    </div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultDetailStr }}
                    </div>
                  </div>
                </div>
                <div v-if="judicialLitigation.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">执行公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in judicialLitigation" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.ppre_sort_time && item.ppre_sort_time ? getDate(Number(item.ppre_sort_time)) : ''}}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                      <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                      <el-descriptions-item label="风险等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="judicialLitigationHD.length>0" class="personalAdvanced" style="margin-left:15px;width: 1000px;">
                  <div v-for="(item,index) in judicialLitigationHD" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString}}</el-descriptions-item>
                      <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.body }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="caseProcessData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">案件流程维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in caseProcessData" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="诉讼标的" label-class-name="descriptions_label">{{ item.ppre_action_object }}</el-descriptions-item>
                      <el-descriptions-item label="案件流程Id" label-class-name="descriptions_label">{{ item.ppre_ajlc_id}}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="审理状态" label-class-name="descriptions_label">{{ item.ppre_trial_procedures }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="dimJudicialData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">裁判文书维度</el-descriptions-item>
                  </el-descriptions>
                  <div class="small_item">
                    <el-descriptions :column="2" border v-for="(tlt,i) in dimJudicialData" :key="i">
                      <!-- <template v-for="(tlt,i) in dimJudicialData"> -->
                      <template v-for="(item,j) in dimJudicialTitleData">
                        <el-descriptions-item v-if="tlt[item.lableId]&&tlt[item.lableId]!=-1" :key="j" :label="item.lablename" label-class-name="descriptions_label">
                          <span v-if="item.lableId == 'ppre_party_position'">
                            <span v-if="tlt[item.lableId] == 'p'">原告</span>
                            <span v-if="tlt[item.lableId] == 'd'">被告</span>
                            <span v-if="tlt[item.lableId] == 't'">第三人</span>
                            <span v-if="tlt[item.lableId] == 'u'">当事人</span>
                          </span>
                          <span v-if="item.lableId == 'ppre_court_rank'">
                            <span v-if="tlt.ppre_court_rank == '4'">基层法院</span>
                            <span v-if="tlt.ppre_court_rank == '3'">市中院</span>
                            <span v-if="tlt.ppre_court_rank == '2'">省高院</span>
                            <span v-if="tlt.ppre_court_rank == '1'">最高院</span>
                          </span>
                          <span v-if="tlt[item.lableId]&&(item.lablename == '审结时间')&&(item.lableId != 'ppre_court_rank')&&(item.lableId != 'ppre_party_position')&&tlt[item.lableId]!=-1">{{getYMDHMS(Number(tlt[item.lableId]))}}</span>
                          <span v-if="tlt[item.lableId]&&(item.lablename != '审结时间')&&(item.lableId != 'ppre_court_rank')&&(item.lableId != 'ppre_party_position')&&tlt[item.lableId]!=-1">{{ tlt[item.lableId]?tlt[item.lableId]:'' }}</span>
                        </el-descriptions-item>
                      </template>
                      <!-- </template> -->
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="courtDimData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">法院公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in courtDimData" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="公告类型" label-class-name="descriptions_label">{{ item.ppre_gg_type }}</el-descriptions-item>
                      <el-descriptions-item label="版面" label-class-name="descriptions_label">{{ item.ppre_layout }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="openDimData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">开庭公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in openDimData" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="法官" label-class-name="descriptions_label">{{ item.ppre_judge }}</el-descriptions-item>
                      <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="开庭时间" label-class-name="descriptions_label">{{ item.ppre_court_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="exposureTableData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">曝光台</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in exposureTableData" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="地址" label-class-name="descriptions_label">{{ item.ppre_address }}</el-descriptions-item>
                      <el-descriptions-item label="曝光台ID" label-class-name="descriptions_label">{{ item.ppre_exposure_id }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="标的金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                      <el-descriptions-item label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type!=-1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="申请人" label-class-name="descriptions_label">{{ item.ppre_proposer }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="依据" label-class-name="descriptions_label">{{ item.ppre_yiju }}</el-descriptions-item>
                      <el-descriptions-item label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="dishonestInfoData.length>0" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">失信信息维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in dishonestInfoData" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item v-if="item.ppre_age!=-1" label="年龄" label-class-name="descriptions_label">{{ item.ppre_age }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                      <el-descriptions-item label="具体情形" label-class-name="descriptions_label">{{ item.ppre_jtqx }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_lxqk!=-1" label="履行情况" label-class-name="descriptions_label">{{ item.ppre_lxqk }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_money!=-1" label="金额" label-class-name="descriptions_label">{{ item.ppre_money }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type!=-1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_pname!=-1" label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_post_time!=-1" label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_province!=-1" label="省份" label-class-name="descriptions_label">{{ item.ppre_province }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_dishonesty_id!=-1" label="失信公告id" label-class-name="descriptions_label">{{ item.ppre_dishonesty_id }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item label="义务" label-class-name="descriptions_label">{{ item.ppre_yiwu }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yj_code!=-1" label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yjdw!=-1" label="依据单位" label-class-name="descriptions_label">{{ item.ppre_yjdw }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </div>
              <!-- 法院被执行人 (限高信息) -->
              <div v-if="item.ProductId=='F32ea4e6-195c-4e99-9b97-44347cd61b0c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 有命中 -->
                <div v-if="!isNull(item.returnSetList1)" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <template v-for="(eleTitle,i) in heightLimitTitleData">
                      <template v-for="(ele) in item.returnSetList1">
                        <el-descriptions-item :key="i" :label="eleTitle.name" label-class-name="descriptions_label" v-if="!isNull(eleTitle.clo3) && !isNull(eleTitle.clo2) && !isNull(ele.hasOwnProperty(eleTitle.clo2)) && (ele[eleTitle.clo2].hasOwnProperty(eleTitle.clo3))">
                          <span class="l_txt">{{ ele[eleTitle.clo2][eleTitle.clo3] }}</span>
                          <span v-if="isNull(eleTitle.clo3)"></span>
                        </el-descriptions-item>
                      </template>
                    </template>
                  </el-descriptions>
                </div>
              </div>
              <!-- 法院信息详情 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd62b9c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 有命中 -->
                <div v-if="personalAdvanced.length>0" class="personalAdvanced">
                  <div v-for="(item,index) in personalAdvanced" :key="index">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.court }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.caseNo }}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.caseState }}</el-descriptions-item>
                      <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.execMoney }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </div>
              <!-- 法院被执行人详情 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b91-44347cd62b9c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 法院被执行人-高级版有命中 -->
                <div v-if="!isNull(item.returnSetList2)" class="personalAdvanced">
                  <el-descriptions :column="2" border>
                    <template v-for="(ele,i) in item.returnSetList2">
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案号" label-class-name="descriptions_label">{{ ele.execut.casenum?ele.execut.casenum:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="下架标识" label-class-name="descriptions_label">{{ ele.execut.sign?ele.execut.sign:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="个人匹配度" label-class-name="descriptions_label">{{ ele.execut.matchRatio?ele.execut.matchRatio:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="法院名称" label-class-name="descriptions_label">{{ ele.execut.court?ele.execut.court:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="五级分类" label-class-name="descriptions_label">{{ ele.execut.eventLevel?ele.execut.eventLevel:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="执行金额" label-class-name="descriptions_label">{{ ele.execut.money?ele.execut.money:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号描述" label-class-name="descriptions_label">{{ ele.execut.signalDesc?ele.execut.signalDesc:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="名称" label-class-name="descriptions_label">{{ ele.execut.name?ele.execut.name:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号等级" label-class-name="descriptions_label">{{ ele.execut.signalRating?ele.execut.signalRating:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="立案日期" label-class-name="descriptions_label">{{ ele.execut.time?ele.execut.time:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案件状态" label-class-name="descriptions_label">{{ ele.execut.statute?ele.execut.statute:'' }}</el-descriptions-item>
                    </template>
                  </el-descriptions>
                </div>
              </div>
              <!-- 法院裁决文书 -->
              <div v-if="item.ProductId=='F32ea4e6-195c-4e99-9b92-44347cd62b9c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
              </div>
              <div v-if="isHasRiskData&&(item.Sort == litigationRisk.length)" class="tips">
                <p>注：</p>
                <p>风险等级：根据诉讼风控规则加工得出，用于识别当事人在案件中的风险等级，分为1-7级，等级越低，风险越高</p>
                <p>匹配度：值越大，表示匹配程度越高。0.4大概率不是本人，0.6-0.7是本人概率较高，0.8-0.9基本确定是本人案件。</p>
              </div>
            </div>
            <div v-if="item.Category == '信用风险'">
              <div v-if="item.Sort == 1" class="category_title category_title00"> {{item.Category}}查询</div>
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b1c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b2c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b3c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
              </div>
              <!-- 逾期风险扫描 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b4c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
                <el-table v-if="!isNull(overdueRiskData)" :data="overdueRiskData" border>
                  <el-table-column prop="name" align="center" label="比中项目" />
                  <el-table-column prop="result" align="center" label="结果">
                    <template slot-scope="{ row }">
                      <span>{{row.result}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-if="item.Category == '商业风险'">
              <div v-if="item.Sort == 1" class="category_title category_title00"> {{item.Category}}查询</div>
              <!-- 个人工商记录查询 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-45347cd61b4c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">
                      <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                      <span v-else>{{ item.ResultStr ? item.ResultStr : '存在风险' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 企业任职画像 -->
              <div v-if="item.ProductId=='f32ea4e6-196c-4e99-9b97-45347cd61b4c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box bg_result_box00">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right bg_widthauto">
                      <p class="pic_txt" v-for="(cur,j) in item.ResultDetailStr.split(';')" :key="j+'o'">{{cur}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="(item.Category == '教育风险')&&!isNull(educInfoData)" class="mb24">
              <div v-if="item.Sort == 1" class="category_title category_title00"> {{item.Category}}查询</div>
              <div class="bg_des_box">
                <div class="bg_des_left">{{ item.Product }}</div>
                <div class="bg_des_right">{{ item.ProductDescri }}</div>
              </div>
              <!-- <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
              <el-table v-if="!isNull(educInfoData)" :data="educInfoData" border>
                <el-table-column prop="name" align="center" label="查询内容" />
                <el-table-column prop="result" align="center" label="查询结果">
                  <template slot-scope="{ row }">
                    <!-- 学习形式 -->
                    <span v-if="row.resultType == 'FC'">
                      <span v-if="row.result == 0">其他</span>
                      <span v-if="row.result == 1">全日制</span>
                      <span v-if="row.result == 2">普通全日制</span>
                      <span v-if="row.result == 3">异值</span>
                      <span v-if="row.result == 4">非全日制</span>
                      <span v-if="row.result == 5">脱产</span>
                      <span v-if="row.result == 6">开放教育</span>
                      <span v-if="row.result == 7">业余</span>
                      <span v-if="row.result == 8">函授</span>
                      <span v-if="row.result == 9">夜大学</span>
                    </span>
                    <!-- 学习层次 -->
                    <span v-else-if="row.resultType == 'LC'">
                      <span v-if="row.result == 0">本科</span>
                      <span v-if="row.result == 1">硕士</span>
                      <span v-if="row.result == 2">博士</span>
                      <span v-if="row.result == -1">专科</span>
                      <span v-if="row.result == -2">高中</span>
                      <span v-if="row.result == -3">中专</span>
                      <span v-if="row.result == -4">初中</span>
                      <span v-if="row.result == -5">小学</span>
                      <span v-if="row.result == -6">其他</span>
                    </span>
                    <span v-else>{{row.result}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div v-if="flagIsAuthorize">
          <div class="flagIsAuthorize"><i class="el-icon-warning">&nbsp;&nbsp;需要候选人授权,授权短信已发送至候选人，请等待候选人签署电子签后查看结果</i></div>
          <el-button type="primary" style="margin-left: 12px;" @click="getcertorderdetail">查询结果</el-button>
        </div>
      </div>

      <div v-if="hasResult" class="result_report_box">
        <div ref="pdf" class="result_report" id="pdf_details">
          <div class="logo">
            <img src="../../assets/images/newlogo.png" alt="" id="logo" ref="pdflogo">
          </div>
          <div class="rpTirle">闪 查 报 告</div>
          <div style="margin: 24px 0;">
            <div class="rpContent flex">
              <div class="dot dot1"></div>
              <div class="dot dot2"></div>
              <div class="dot dot3"></div>
              <div style="margin: 0 8px;">报告内容</div>
              <div class="dot dot3"></div>
              <div class="dot dot2"></div>
              <div class="dot dot1"></div>
            </div>
            <div class="tableTitle">报告信息</div>
            <div>
              <el-descriptions style="width: 1000px;" :column="2" border>
                <el-descriptions-item label="候选⼈姓名" label-class-name="descriptions_label">{{ result.order.SurveyName }}</el-descriptions-item>
                <el-descriptions-item label="身份证号" label-class-name="descriptions_label">{{ encryption(result.order.SurveyIdcard) }}</el-descriptions-item>
                <el-descriptions-item label="套餐名称" label-class-name="descriptions_label">自定义</el-descriptions-item>
                <el-descriptions-item label="报告版本" label-class-name="descriptions_label">最终版</el-descriptions-item>
                <el-descriptions-item label="委托方" label-class-name="descriptions_label">{{result.CustomerName}}</el-descriptions-item>
                <el-descriptions-item label="查询结果" label-class-name="descriptions_label">
                  <i v-if="result.order.IsRiskResult == '0'" class="el-icon-success res_icon_right"></i>
                  <span v-else>详见下文</span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div class="resultTitle flex sb">
            <div class="flex">
              <div class="res_title">报告编号：</div>
              <div class="res_content">{{ result.order.OrderId }}</div>
            </div>
            <div class="flex">
              <div class="res_title">查询时间：</div>
              <div class="res_content">{{ result.order.CreatedTime.replace('T',' ') }}</div>
            </div>
          </div>
          <!-- 风险提示 -->
          <div class="mb24">
            <div class="tableTitle">风险提示</div>
            <div class="w1000 c_border">
              <p style="line-height:20px;margin:0;" v-show="!isNull(riskWarningData)&&result.order.IsRiskResult != '0'" v-for="(child,i) in riskWarningData" :key="i+'p'">
                <span>{{i+1}}、候选人存在{{child.Category}}记录，详见下文。</span>
              </p>
              <span style="line-height:20px;margin:0;" v-if="result.order.IsRiskResult == '0'">无风险记录</span>
            </div>
          </div>
          <!-- 报告正文 第二页开始-->
          <div class="mb24">
            <div class="tableTitle">报告正文</div>
            <div class="mb24" v-for="(item,index) in result.orderDetailList" :key="index">
              <!-- 身份风险查询 -->
              <div v-if="item.Category == '身份风险'" class="small_item">
                <div v-if="(item.Sort == 1)&&(!isNull(identityReport)||!isNull(telReport)||!isNull(bankReport))" class="category_title"> {{item.Category}}查询</div>
                <!-- 身份信息验证 -->
                <div v-if="item.ProductId == 'f11ea4e6-195c-4e99-9b97-44347cd61b0c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <!-- <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                  <el-table :data="identityReport" border style="width:1001px;">
                    <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                    <el-table-column prop="result" align="center" label="查询结果" width="350" />
                    <el-table-column prop="truth" align="center" label="真实性" width="140">
                      <template slot-scope="{ row }">
                        <span v-if="row.truth == '0'">一致</span>
                        <span v-else-if="isNull(row.truth)"></span>
                        <span v-else>不一致</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" align="center" label="说明" width="330" />
                  </el-table>
                </div>
                <!-- 身份,手机号验证 -->
                <div v-if="(item.ProductId == 'f21ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(telReport)" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <!-- <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                  <el-table :data="telReport" border style="width:1001px;">
                    <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                    <el-table-column prop="result" align="center" label="查询结果" width="350" />
                    <el-table-column prop="truth" align="center" label="真实性" width="140">
                      <template slot-scope="{ row }">
                        <span v-if="row.truth == '0'">一致</span>
                        <span v-else-if="isNull(row.truth)"></span>
                        <span v-else>不一致</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" align="center" label="说明" width="330" />
                  </el-table>
                </div>
                <!-- 身份,手机号验证,银行卡验证 -->
                <div v-if="(item.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(bankReport)" class="small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <!-- <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div> -->
                  <el-table :data="bankReport" border style="width:1001px;">
                    <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                    <el-table-column prop="result" align="center" label="查询结果" width="350" />
                    <el-table-column prop="truth" align="center" label="真实性" width="140">
                      <template slot-scope="{ row }">
                        <span v-if="row.truth == '0'">一致</span>
                        <span v-else-if="isNull(row.truth)"></span>
                        <span v-else>不一致</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" align="center" label="说明" width="330" />
                  </el-table>
                </div>
              </div>
              <div v-if="item.Category == '不良风险'" class="small_item mb24">
                <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">不良行为记录</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
                <!-- <el-descriptions style="width: 1000px;" :column="1" border>
                    <el-descriptions-item label="查询结果" label-class-name="descriptions_label">{{ item.ResultStr }}</el-descriptions-item>
                    <el-descriptions-item label="不良行为记录" label-class-name="descriptions_label">{{item.ResultDetailStr}}</el-descriptions-item>
                  </el-descriptions> -->
              </div>
              <div v-if="item.Category == '诉讼风险'" class="small_item">
                <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
                <!-- 司法诉讼 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b9c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>0))?item.ResultStr.split('|')[0]:'' }}</p>
                        <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>1))?item.ResultStr.split('|')[1]:'' }}</p>
                      </div>
                    </div>
                    <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                      <div class="bg_result_cell bg_result_left">具体结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}
                      </div>
                    </div>
                  </div>
                  <div v-if="judicialLitigation.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">执行公告维度</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in judicialLitigation" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                        <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.ppre_sort_time && item.ppre_sort_time ? getDate(Number(item.ppre_sort_time)) : ''}}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                        <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                        <el-descriptions-item label="风险等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                  <div v-if="caseProcessData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">案件流程维度</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in caseProcessData" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="诉讼标的" label-class-name="descriptions_label">{{ item.ppre_action_object }}</el-descriptions-item>
                        <el-descriptions-item label="案件流程Id" label-class-name="descriptions_label">{{ item.ppre_ajlc_id}}</el-descriptions-item>
                        <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                        <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                        <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause }}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                        <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                          <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                          <span v-if="item.ppre_court_rank == '3'">市中院</span>
                          <span v-if="item.ppre_court_rank == '2'">省高院</span>
                          <span v-if="item.ppre_court_rank == '1'">最高院</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                        <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                        <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                          <span v-if="item.ppre_party_position == 'p'">原告</span>
                          <span v-if="item.ppre_party_position == 'd'">被告</span>
                          <span v-if="item.ppre_party_position == 't'">第三人</span>
                          <span v-if="item.ppre_party_position == 'u'">当事人</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                        <el-descriptions-item label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                        <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                        <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                        <el-descriptions-item label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                        <el-descriptions-item label="审理状态" label-class-name="descriptions_label">{{ item.ppre_trial_procedures }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                  <div v-if="dimJudicialData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">裁判文书维度</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions style="width: 1000px;" :column="2" border class="small_item" v-for="(tlt,i) in dimJudicialData" :key="i">
                      <!-- <template v-for="(tlt,i) in dimJudicialData"> -->
                      <template v-for="(item,j) in dimJudicialTitleData">
                        <el-descriptions-item v-if="tlt[item.lableId]&&tlt[item.lableId]!=-1" :key="j" :label="item.lablename" label-class-name="descriptions_label">
                          <span v-if="item.lableId == 'ppre_party_position'">
                            <span v-if="tlt[item.lableId] == 'p'">原告</span>
                            <span v-if="tlt[item.lableId] == 'd'">被告</span>
                            <span v-if="tlt[item.lableId] == 't'">第三人</span>
                            <span v-if="tlt[item.lableId] == 'u'">当事人</span>
                          </span>
                          <span v-if="item.lableId == 'ppre_court_rank'">
                            <span v-if="tlt.ppre_court_rank == '4'">基层法院</span>
                            <span v-if="tlt.ppre_court_rank == '3'">市中院</span>
                            <span v-if="tlt.ppre_court_rank == '2'">省高院</span>
                            <span v-if="tlt.ppre_court_rank == '1'">最高院</span>
                          </span>
                          <span v-if="tlt[item.lableId]&&(item.lablename == '审结时间')&&(item.lableId != 'ppre_court_rank')&&(item.lableId != 'ppre_party_position')&&tlt[item.lableId]!=-1">{{getYMDHMS(Number(tlt[item.lableId]))}}</span>
                          <span v-if="tlt[item.lableId]&&(item.lablename != '审结时间')&&(item.lableId != 'ppre_court_rank')&&(item.lableId != 'ppre_party_position')&&tlt[item.lableId]!=-1">{{ tlt[item.lableId]?tlt[item.lableId]:'' }}</span>
                        </el-descriptions-item>
                      </template>
                      <!-- </template> -->
                    </el-descriptions>
                  </div>
                  <div v-if="courtDimData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">法院公告维度</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in courtDimData" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                        <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                          <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                          <span v-if="item.ppre_court_rank == '3'">市中院</span>
                          <span v-if="item.ppre_court_rank == '2'">省高院</span>
                          <span v-if="item.ppre_court_rank == '1'">最高院</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                        <el-descriptions-item label="公告类型" label-class-name="descriptions_label">{{ item.ppre_gg_type }}</el-descriptions-item>
                        <el-descriptions-item label="版面" label-class-name="descriptions_label">{{ item.ppre_layout }}</el-descriptions-item>
                        <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                          <span v-if="item.ppre_party_position == 'p'">原告</span>
                          <span v-if="item.ppre_party_position == 'd'">被告</span>
                          <span v-if="item.ppre_party_position == 't'">第三人</span>
                          <span v-if="item.ppre_party_position == 'u'">当事人</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_pname != -1" label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                        <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                        <el-descriptions-item label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                  <div v-if="openDimData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">开庭公告维度</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in openDimData" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                        <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                          <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                          <span v-if="item.ppre_court_rank == '3'">市中院</span>
                          <span v-if="item.ppre_court_rank == '2'">省高院</span>
                          <span v-if="item.ppre_court_rank == '1'">最高院</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                        <el-descriptions-item label="法官" label-class-name="descriptions_label">{{ item.ppre_judge }}</el-descriptions-item>
                        <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                        <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                          <span v-if="item.ppre_party_position == 'p'">原告</span>
                          <span v-if="item.ppre_party_position == 'd'">被告</span>
                          <span v-if="item.ppre_party_position == 't'">第三人</span>
                          <span v-if="item.ppre_party_position == 'u'">当事人</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                        <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                        <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                        <el-descriptions-item label="开庭时间" label-class-name="descriptions_label">{{ item.ppre_court_time }}</el-descriptions-item>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                  <div v-if="exposureTableData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">曝光台</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in exposureTableData" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="地址" label-class-name="descriptions_label">{{ item.ppre_address }}</el-descriptions-item>
                        <el-descriptions-item label="曝光台ID" label-class-name="descriptions_label">{{ item.ppre_exposure_id }}</el-descriptions-item>
                        <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                        <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                          <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                          <span v-if="item.ppre_court_rank == '3'">市中院</span>
                          <span v-if="item.ppre_court_rank == '2'">省高院</span>
                          <span v-if="item.ppre_court_rank == '1'">最高院</span>
                        </el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_court_type != -1" label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_execmoney != -1" label="标的金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_idcard_no != -1" label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_pname != -1" label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_proposer != -1" label="申请人" label-class-name="descriptions_label">{{ item.ppre_proposer }}</el-descriptions-item>
                        <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_sort_time != -1" label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_title != -1" label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_yiju != -1" label="依据" label-class-name="descriptions_label">{{ item.ppre_yiju }}</el-descriptions-item>
                        <el-descriptions-item label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                        <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                  <div v-if="dishonestInfoData.length>0" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="信息类型" label-class-name="descriptions_label">失信信息维度</el-descriptions-item>
                    </el-descriptions>
                    <div v-for="(item,index) in dishonestInfoData" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="年龄" label-class-name="descriptions_label">{{ item.ppre_age }}</el-descriptions-item>
                        <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                        <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_idcard_no != -1" label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_jtqx != -1" label="具体情形" label-class-name="descriptions_label">{{ item.ppre_jtqx }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_lxqk != -1" label="履行情况" label-class-name="descriptions_label">{{ item.ppre_lxqk }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_money != -1" label="金额" label-class-name="descriptions_label">{{ item.ppre_money }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                        <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_post_time != -1" label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                        <el-descriptions-item label="省份" label-class-name="descriptions_label">{{ item.ppre_province }}</el-descriptions-item>
                        <el-descriptions-item label="失信公告id" label-class-name="descriptions_label">{{ item.ppre_dishonesty_id }}</el-descriptions-item>
                        <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                        <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_sort_time != -1" label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_yiwu != -1" label="义务" label-class-name="descriptions_label">{{ item.ppre_yiwu }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_yj_code != -1" label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                        <el-descriptions-item v-if="item.ppre_yjdw != -1" label="依据单位" label-class-name="descriptions_label">{{ item.ppre_yjdw }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                        <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>

                  <div v-if="judicialLitigationHD.length>0" class="personalAdvanced">
                    <div v-for="(item,index) in judicialLitigationHD" :key="index" class="small_item">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                        <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString}}</el-descriptions-item>
                        <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.body }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                </div>
                <!-- 法院被执行人 (限高信息) -->
                <div v-if="item.ProductId=='F32ea4e6-195c-4e99-9b97-44347cd61b0c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                  </div>
                  <!-- 有命中 -->
                  <div v-if="!isNull(item.returnSetList1)" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <template v-for="(eleTitle,i) in heightLimitTitleData">
                        <template v-for="(ele) in item.returnSetList1">
                          <el-descriptions-item :key="i" :label="eleTitle.name" label-class-name="descriptions_label" v-if="!isNull(eleTitle.clo3) && !isNull(eleTitle.clo2) && !isNull(ele.hasOwnProperty(eleTitle.clo2)) && (ele[eleTitle.clo2].hasOwnProperty(eleTitle.clo3))">
                            <span class="l_txt">{{ ele[eleTitle.clo2][eleTitle.clo3] }}</span>
                            <span v-if="isNull(eleTitle.clo3)"></span>
                          </el-descriptions-item>
                        </template>
                      </template>
                    </el-descriptions>
                  </div>
                </div>
                <!-- 法院信息详情 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd62b9c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                  </div>
                  <!-- 有命中 -->
                  <div v-if="personalAdvanced.length>0" class="personalAdvanced">
                    <div v-for="(item,index) in personalAdvanced" :key="index">
                      <el-descriptions style="width: 1000px;" :column="2" border>
                        <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                        <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString }}</el-descriptions-item>
                        <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.court }}</el-descriptions-item>
                        <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.caseNo }}</el-descriptions-item>
                        <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.caseState }}</el-descriptions-item>
                        <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.execMoney }}</el-descriptions-item>
                        <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                      </el-descriptions>
                    </div>
                  </div>
                </div>
                <!-- 法院被执行人详情 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b91-44347cd62b9c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                  </div>
                  <!-- 法院被执行人-高级版有命中 -->
                  <div v-if="!isNull(item.returnSetList2)" class="personalAdvanced">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <template v-for="(ele,i) in item.returnSetList2">
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案号" label-class-name="descriptions_label">{{ ele.execut.casenum?ele.execut.casenum:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="下架标识" label-class-name="descriptions_label">{{ ele.execut.sign?ele.execut.sign:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="个人匹配度" label-class-name="descriptions_label">{{ ele.execut.matchRatio?ele.execut.matchRatio:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="法院名称" label-class-name="descriptions_label">{{ ele.execut.court?ele.execut.court:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="五级分类" label-class-name="descriptions_label">{{ ele.execut.eventLevel?ele.execut.eventLevel:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="执行金额" label-class-name="descriptions_label">{{ ele.execut.money?ele.execut.money:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号描述" label-class-name="descriptions_label">{{ ele.execut.signalDesc?ele.execut.signalDesc:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="名称" label-class-name="descriptions_label">{{ ele.execut.name?ele.execut.name:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号等级" label-class-name="descriptions_label">{{ ele.execut.signalRating?ele.execut.signalRating:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="立案日期" label-class-name="descriptions_label">{{ ele.execut.time?ele.execut.time:'' }}</el-descriptions-item>
                        <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案件状态" label-class-name="descriptions_label">{{ ele.execut.statute?ele.execut.statute:'' }}</el-descriptions-item>
                      </template>
                    </el-descriptions>
                  </div>
                </div>
                <!-- 法院裁决文书 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b92-44347cd62b9c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                    <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                      <div class="bg_result_cell bg_result_left">具体结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="isHasRiskData&&(item.Sort == litigationRisk.length)" class="tips small_item">
                  <p>注：</p>
                  <p>风险等级：根据诉讼风控规则加工得出，用于识别当事人在案件中的风险等级，分为1-7级，等级越低，风险越高</p>
                  <p>匹配度：值越大，表示匹配程度越高。0.4大概率不是本人，0.6-0.7是本人概率较高，0.8-0.9基本确定是本人案件。</p>
                </div>
              </div>
              <div v-if="item.Category == '信用风险'" class="small_item">
                <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
                <!-- 信用风险、风险名单、网贷黑名单 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b1c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b2c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b3c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                    <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                      <div class="bg_result_cell bg_result_left">具体结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                    </div>
                  </div>
                </div>
                <!-- 逾期风险扫描 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b4c'" class="mb24 small_item">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                    <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                      <div class="bg_result_cell bg_result_left">具体结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                    </div>
                  </div>
                  <el-table v-if="!isNull(overdueRiskData)" :data="overdueRiskData" border style="width:1001px;">
                    <el-table-column prop="name" align="center" label="比中项目" width="501" />
                    <el-table-column prop="result" align="center" label="结果" width="500">
                      <template slot-scope="{ row }">
                        <span>{{row.result}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div v-if="item.Category == '工作风险'" class="small_item">
                <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
                <!-- 个人工商记录查询 -->
                <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-45347cd61b4c'" class="mb24">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                        <span v-else>存在风险</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 企业任职画像 -->
                <div v-if="item.ProductId=='f32ea4e6-196c-4e99-9b97-45347cd61b4c'" class="mb24">
                  <div class="bg_des_box">
                    <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                    <div class="bg_des_right">{{ item.ProductDescri }}</div>
                  </div>
                  <div class="bg_result_box">
                    <div class="bg_result_item">
                      <div class="bg_result_cell bg_result_left">查询结果</div>
                      <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                    </div>
                    <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                      <div class="bg_result_cell bg_result_left">具体结果</div>
                      <div class="bg_result_cell bg_result_right">
                        <p class="pic_txt" v-for="(cur,j) in item.ResultDetailStr.split(';')" :key="j+'o'">{{cur}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="(item.Category == '教育风险')&&!isNull(educInfoData)" class="small_item mb24">
                <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <el-table v-if="!isNull(educInfoData)" :data="educInfoData" border style="width:1001px;">
                  <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                  <el-table-column prop="result" align="center" label="查询结果" width="821">
                    <template slot-scope="{ row }">
                      <!-- 学习形式 -->
                      <span v-if="row.resultType == 'FC'">
                        <span v-if="row.result == 0">其他</span>
                        <span v-if="row.result == 1">全日制</span>
                        <span v-if="row.result == 2">普通全日制</span>
                        <span v-if="row.result == 3">异值</span>
                        <span v-if="row.result == 4">非全日制</span>
                        <span v-if="row.result == 5">脱产</span>
                        <span v-if="row.result == 6">开放教育</span>
                        <span v-if="row.result == 7">业余</span>
                        <span v-if="row.result == 8">函授</span>
                        <span v-if="row.result == 9">夜大学</span>
                      </span>
                      <!-- 学习层次 -->
                      <span v-else-if="row.resultType == 'LC'">
                        <span v-if="row.result == 0">本科</span>
                        <span v-if="row.result == 1">硕士</span>
                        <span v-if="row.result == 2">博士</span>
                        <span v-if="row.result == -1">专科</span>
                        <span v-if="row.result == -2">高中</span>
                        <span v-if="row.result == -3">中专</span>
                        <span v-if="row.result == -4">初中</span>
                        <span v-if="row.result == -5">小学</span>
                        <span v-if="row.result == -6">其他</span>
                      </span>
                      <span v-else>{{row.result}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="small_item">
            <div class="statement">声明：</div>
            <div class="statementContent">授{{result.CustomerName}}的委托，并由授权人 <span style="color: #19bd92;">{{result.order.SurveyName}}</span> 书面授权同意，以降低招聘风险为目的，按照委托方及授权人提供的信息，通过专业闪查流程，进行背景信息核实工作。</div>
            <div class="statementContent">以上信息均通过符合法律法规的途径获得，其信息均为候选人资质、工作背景相关信息掌握机构所提供，由浙江杰博人力资源股份有限公司（以下简称“杰博”）记录整理而成，且不代表“杰博”及公司任何员工的主观意见。</div>
            <div class="statementContent">本报告内容不得向任何第三方透露，仅供委托方参考，“杰博”不承担此报告产生的任何法律责任。</div>
          </div>
        </div>
      </div>
      <div class="reading">
        <el-dialog :visible.sync="visibleReading" width="1000px" :show-close="false" :close-on-click-modal="false">
          <div class="readDialog">
            <div class="diaTitle">使用说明</div>
            <div style="margin-top:15px;padding-bottom:15px;">
              <div class="note_txt">
                <p>欢迎使用浙江杰博人力资源股份有限公司（以下简称：杰博股份）小杰闪查服务！</p>
                <p>根据国家相关法律法规的要求， 特此说明：</p>
                <p><span class="weight">1.用户需确保查询第三人个人（以下简称被查询人）信息时已获得被查询人书面或电子授权，</span>授权信息需包含但不限于用户在杰博股份系统中所查询的相关内容。用户应采取必要的手段验证被查询人的身份。如因用户未获取相应授权或未验证被查询方身份而导致的任何纠纷，由用户承担全部责任。</p>
                <p>2.用户在使用系统时，应提供正确，完整，真实，合法的被查询人信息，<span class="weight">如因用户提供的信息不准确，不及时，不合法所引起的后果，由用户承担全部责任。</span></p>
                <p>3.用户从杰博股份系统获得的任何信息（无论以何种方式体现和存储、无论以何种形式记载，下同）<span class="weight">仅用于招聘、录用该被查询人时决策参考用途，</span> 用户不得将从杰博股份获取的信息用作商业用途以及其他用途。</p>
                <p>4.用户需遵守国家法律、法规及地方规章、制度、规例、法令和命令，对核实结果尽保密义务，对从杰博股份查询系统获得的任何信息均负有永久保密义务。不得将信息提供给其他单位或个人，不得将核查结果在网络、媒体或其他平台予以披露。未经杰博股份书面许可，用户不得将信息提供、泄露或其他途径、方式让第三方（包括被查询人）知悉。如用户依据法律、法规或监管机构的要求需要披露信息，应提前一个工作日以书面形式通知杰博股份，同时附上披露依据。</p>
                <p>5.用户应尽最大谨慎、注意义务使用查询、获得的信息。未妥善使用核查信息给被查询人造成侵权、隐私泄露或其他后果，与杰博股份无关，由用户自行承担。用户给杰博股份造成损失，还应赔偿杰博股份因此遭受的损失。</p>
                <p>6.用户在企业内部使用过程中，也不得通过任何形式（包括但不限于互联网运营平台，移动APP、电话、短信、邮件、传真等方式）将杰博股份提供的服务内容或查询结果提供或展示给任何第三方。<span class="weight">用户承担因非法使用杰博股份信息所产生的一切后果和责任。</span></p>
                <p>7.用户必须在中国境内（不含港、澳、台）查询及使用杰博股份的信息。用户用于查询访问杰博股份系统的IP地址，服务器（自有或租用）物理地址必须在中国境内（不含港、澳、台）。用户应对用户终端设备的安全性负责，若由于用户终端设备含有病毒、木马程序或其他恶意程序，或由于用户工作人员错误操作，恶意查询，所造成的一切责任和损失由用户承担。</p>
                <p>8.用户未经杰博股份书面授权同意，不得在任何地方（包括但不限于广告，宣传）或以任何方式使用杰博的商标、品牌和企业名称、标志。用户不得向任何第三方透漏公布与杰博股份的合作事项，价格，但因法律法规、监管机构要求除外。</p>
                <p>9.杰博股份发现用户查询异常，威胁到杰博股份系统安全时，杰博股份有权采取中止服务的措施，并通知用户。</p>

                <div class="diaTitle">免责说明</div>

                <p>1.杰博股份在接受由用户发起的服务请求时，<span class="weight">用户必须保证已获得相关被查询人的合法授权。</span> 如果发现未经授权或超越授权范围时，杰博股份有权追究用户的责任，如杰博股份因此遭受任何损失，有权要求用户承担全额赔偿责任。</p>
                <p>2.用户通过本系统获取的所有信息仅供用户参考使用，本网站不承担用户因使用这些信息产生的任何法律责任。</p>
                <p>3.用户通过本网站获取的所有信息均是浙江杰博股份人力资源有限公司通过各种渠道和途径采集的，请用户自行判断通过本网站获取的信息的真实性和准确性。</p>
                <p><span class="weight">4.用户应妥善保管用户账号及密码。</span> 用户自己导致账号或密码泄露，或将账号密码告知他人或与他人共享注册账户，由此导致的任何损失，本网站不负任何责任。</p>
                <p>5.当政府或司法机关依照法定程序要求本网站披露用户资料时，本网站将根据政府或执法机关之要求，或出于国家利益、公共安全之目的，本网站有权提供用户资料。在此情况下之任何披露，本网站不承担责任。</p>
                <p>6.如因系统维护或升级而需暂停服务时，本网站将事先公告。若因线路及非本网站控制范围内的硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，本网站不承担责任。</p>
                <p>7.任何由于计算机问题、黑客攻击、计算机病毒侵入或发作、因政府行为而造成的暂时性关闭等影响网络正常经营的不可抗力而造成用户账号或密码丢失、被盗用或被篡改等，本网站均得免责。但是我们将会尽合理的可能协助处理善后事宜，并努力减少用户可能遭受的经济损失。如用户发现账号遭他人非法使用，应尽早通知我们，以便我们及时提供帮助。</p>
                <p>8.当出现以下不可抗力因素如:战争、骚乱、洪水、地震、台风、国家公布的疫情等事件，或因政府颁布法律、法规、命令及其他政府行为，或因停电、系统故障、传输线路、通信故障及通信线路等不可预测因素,或因数据源单位原因,导致系统不能或部分不能履行，杰博股份无需承担任何责任，但是杰博股份会采取合理措施防止损失的扩大，并及时以本协议约定的有效书面形式通知。</p>
                <p>9.本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准，使用者因触犯中华人民共和国法律的，一切后果自己负责，本网站不承担任何责任。</p>
                <p>10.本免责声明以及其修改权、更新权及最终解释权均属本网站所有。</p>
              </div>
            </div>
          </div>
          <div class="dialogFoot">
            <div style="line-height: 30px;">
              <el-checkbox v-model="hasRead">我已充分阅读以上声明，同意并接受上述声明内容。</el-checkbox>
            </div>
            <el-button type="primary" size="small" style="margin-right: 10px;" :disabled="!hasRead" @click="closeRead">继续</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 批量查询 -->
      <el-dialog :visible.sync="batchQueryVisible" title="批量查询" width="950px" class="up_dialog">
        <div class="dia_search_box">
          <div class="dia_search_item">
            <p>姓名:</p>
            <el-input v-model="batchQuery.strUserName" size="small" style="width: 180px;" clearable />
          </div>
          <div class="dia_search_item">
            <p>联系方式:</p>
            <el-input v-model="batchQuery.strMobile" size="small" style="width: 180px;" clearable />
          </div>
          <div class="dia_search_item">
            <el-button type="primary" size="small" @click="batchSearchHandle">搜索</el-button>
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" v-loading="tableLoading" :highlight-current-row="true" @selection-change="handleSelectionChange" :max-height="500" :data="tableQueryData" style="width:100%">
          <el-table-column type="selection" align="center" width="55" label-class-name="com_Selection"></el-table-column>
          <template v-for="(item,index) in tableQueryTitle">
            <el-table-column v-if="item.StrColumName.indexOf('序号')>-1 || item.StrColumName.indexOf('姓名')>-1 || item.StrColumName.indexOf('联系方式')>-1 || item.StrColumName.indexOf('项目名称')>-1 || item.StrColumName.indexOf('身份证')>-1" :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index+'A'" align="center" :width="item.StrColumName.indexOf('序号')>-1 ? '60px' : item.StrColumName.indexOf('身份证')>-1 ? '180px' : ''">
              <template slot-scope="{row}">
                <span v-if="item.StrColumName == '入职时间'">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId].replace('T',' ')}}</span>
                <span v-else-if="(item.StrColumName == '预定到岗时间')&&(row[item.StrColumId]=='未确定')" @click="editDtreachtime(row)" style="cursor: pointer;color:#333;font-weight: bold;text-decoration: underline;" title="点击可修改到岗时间">{{ row[item.StrColumId]}}<i class="el-icon-edit" style="font-size: 14px;color: #333;"></i></span>
                <span v-else-if="item.StrColumName.indexOf('在职天数')>-1">{{ isMinus(row[item.StrColumId]) ? '0' : row[item.StrColumId]}}</span>
                <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="银行卡号" align="center" prop="Bankcard" width="180px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="操作" width="105px">
            <template slot-scope="scope">
              <el-button type="success" size="mini" plain @click="editPerson(scope.row,scope.$index)">修改信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="batchCurrentChange" :current-page.sync="batchQuery.currpage" :page-size="batchQuery.perpage" @size-change="batchSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="batchTotal"></el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="batchQueryVisible=false">取消</button>
          <button class="search" :disabled="isBatchCheck" style="margin-left:10px;font-weight:600" @click="confirmQuery">确定</button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="visibleEditPerson" width="500px" title="修改信息">
        <el-form ref="ruleEditPerson" :model="info" label-width="100px">
          <el-form-item label="姓名" prop="StrUserName">
            <el-input v-model="info.StrUserName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号码" prop="StrMobile">
          <el-input v-model="info.Tel"></el-input>
        </el-form-item> -->
          <el-form-item label="身份证" prop="StrIdCard">
            <el-input v-model="info.StrIdCard"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="Bankcard">
            <el-input v-model="info.Bankcard"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="visibleEditPerson = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addIdcard">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="showCreateQRcode" width="450px" title="创建闪查二维码">
        <el-form ref="QRform" :model="QRform" :rules="QRrule" label-width="100px">
          <el-form-item label="项目名称">
            <el-select ref="mySelected" v-model="QRform.ProjectId" style="width:220px" size="small" placeholder="" readonly disabled>
              <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="套餐名称" prop="Name">
            <el-input v-model="QRform.Name" style="width:220px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="使用次数" prop="UseCount">
            <el-input type="number" v-model="QRform.UseCount" style="width:220px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="生效时间" prop="TakeEffectTime">
            <el-date-picker v-model="QRform.TakeEffectTime" type="datetime" placeholder="选择日期时间" default-time="24:00:00">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="失效时间" prop="LoseTime">
            <el-date-picker v-model="QRform.LoseTime" type="datetime" placeholder="选择日期时间" default-time="24:00:00">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="showCreateQRcode = false">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmCreateQRcode">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="showQRcode" width="531px">
        <div class="QRcodeCreateTime" v-if="QRcodeCreateTime">二维码生成时间：{{QRcodeCreateTime}}</div>
        <el-image style="width: 500px;height: 500px;" :src=" headPath + QRCodeSrc" alt=""></el-image>
      </el-dialog>

      <el-dialog title="批量导入查询" :visible.sync="showImport" width="550px">
        <el-form label-width="100px">
          <el-form-item label="上次导入进度:" v-if="nowProgress" prop="phoneNum">
            <div style="margin-left: 5px;" class="progress">
              <el-progress style="width: 350px;margin-top: 10px;" :text-inside="true" :stroke-width="24" :percentage="nowProgress" :status="nowProgress==100 ? 'success' : ''" />
            </div>
          </el-form-item>
          <el-form-item label="导入模板:" prop="phoneNum">
            <el-button type="text" class="blueName cp" @click="downLoadHandle">下载模板</el-button>
          </el-form-item>
          <el-form-item label="导入账单:" prop="fileUrl">
            <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="primary">导入账单</el-button>
            </el-upload>
          </el-form-item>
          <div class="errorTxt">{{ errorTxt }}</div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showImport = false" size="small">取消</el-button>
          <el-button type="primary" size="small" @click="confirmImport" :loading="uploading" v-if="nowProgress!=100">确定</el-button>
          <el-button type="primary" disabled size="small" v-if="nowProgress==100">导入已完成</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    downloadPDF
  } from "@/utils/pdf.js";
  import moment from 'moment';
  export default {
    data() {
      var validatecard = (rule, value, callback) => {
        if (value.length != 18) {
          callback(new Error("身份证号码格式不正确"));
        } else {
          this.checkIdcard(value) ?
            callback() :
            callback(new Error("身份证号码格式不正确"));
        }
      };
      var validateTel = (rule, value, callback) => {
        if (value.toString().length != 11) {
          callback(new Error("手机号码格式不正确"));
        } else {
          callback();
        }
      };
      return {
        hasRead: false,
        isBatchCheck: false, //是否批量查询完成
        needIdcard: false,
        needEntName: false,
        visibleReading: false,
        activeName: "first",
        tableData: [],
        identityReport: [], // 身份信息验证
        telReport: [],
        bankReport: [],
        remainingTimes: 0, //剩余次数
        queryTimes: 0, //查询次数
        AmountSpent: 0, //消费金额
        form: {
          name: "",
          idcard: "",
          tel: "",
          Bankcard: "",
          BusiType: "2", //2代表是项目的 1代表是客户
          BusiId: "",
          productid: [],
          Entcode: "",
          Entname: "",
        },
        Id: "",
        rules: {
          name: {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          idcard: [{
              required: true,
              message: "请输入身份证号码",
              trigger: "blur",
            },
            // {
            //   message: '请输入正确的身份证号码',
            //   validator: validatecard,
            //   trigger: 'blur'
            // }
          ],
          tel: [{
              required: true,
              message: "请输入手机号码",
              trigger: "blur",
            },
            // {
            //   message: '请输入正确的手机号码',
            //   validator: validateTel,
            //   trigger: 'blur'
            // }
          ],
          Bankcard: {
            required: true,
            message: "请输入银行卡号",
            trigger: "blur",
          },
          Entname: {
            required: true,
            message: "请输入企业名称",
            trigger: "blur"
          },
          Entcode: {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
        },
        listQuery: {
          BusiId: "",
          BusiType: 2,
        },
        flagIsAuthorize: false, // 是否需要电子签认证
        hasCheck: false,
        needPhone: false,
        needBank: false,
        needEnt: false,
        checkedAll: false, // 全选
        multipleSelection: [],
        hasResult: false,
        result: {}, // 查询结果列表
        judicialLitigation: [], // 司法诉讼
        personalAdvanced: [], // 法院信息详情-个人高级版
        expvivw: false,
        educInfoData: [], //学历信息列表
        loanBlacklistData: [], //网贷黑名单
        overdueRiskData: [], //逾期风险
        riskWarningData: [], //风险提示
        dimJudicialTitleData: [], //裁判文书表头
        caseProcessData: [], //案件流程维度
        dimJudicialData: [], //裁判文书表头
        courtDimData: [], //法院公告维度
        openDimData: [], //开庭公告维度
        exposureTableData: [], //曝光台
        dishonestInfoData: [], //失信信息
        litigationRisk: [],
        heightTitleData: [], //法院被执行人—高级版表头
        heightLimitTitleData: [], //法院被执行人—限高版表头
        resProjectList: [], //项目列表
        tableLoading: false,
        tableQueryTitle: [], //流程通过人员列表表头
        tableQueryData: [], //流程通过人员列表数据
        batchQuery: {
          StrnowState: "通过", //状态
          strProjectName: "", // 项目名称
          strUserName: "", // 姓名
          strMobile: "", // 联系方式
          strJobInf: "", //岗位
          strSource: "", //来源
          strreuser: "", //招聘顾问
          strUserkf: "", //客服
          stroutid: "", //导出选中id
          currpage: 1, // 分页
          perpage: 10,
          strSourcejl: "", //简历来源
          roletype: localStorage.loginRoletype,
        },
        // 表头参数
        titleQuery: {
          ststus: "通过", //报名 已约面 到面 通过 在职 异常 离职 流程已入职 流程未入职（流程统计中）
        },
        multipleTable: [], //选中的人员
        batchQueryVisible: false,
        batchTotal: 0,
        totalPrice: 0,
        visibleEditPerson: false,
        info: {
          StrUserName: '',
          StrIdCard: '',
          index: 0,
          Bankcard: ''
        },
        isBtnLoading: false, //按钮加载状态
        creditRisks: [], //信用风险
        // 按钮权限参数
        butQuery: {
          path: '/backgroundCheck',
          powerEnName: 'product'
        },
        permissionLists: [],
        isHasRiskData: false,
        showCreateQRcode: false, //创建二维码弹窗
        showQRcode: false, //二维码弹窗
        QRcodeCreateTime: '', //二维码创建时间
        headPath: this.$store.state.EMP.imgPath,
        QRCodeSrc: '', //二维码url
        QRform: {
          BusiType: 2, //1外部，2 内部
          ProjectId: '', //项目id
          BusiIds: '', //闪查项目id
          UseCount: '', //使用次数
          TakeEffectTime: '', //生效时间
          LoseTime: '', //失效时间
          Name: ''
        },
        QRrule: {
          Name: {
            required: true,
            message: "请输入套餐名称",
            trigger: "blur",
          },
          UseCount: {
            required: true,
            message: "请输入使用次数",
            trigger: "blur",
          },
          LoseTime: {
            required: true,
            message: "请选择失效时间",
            trigger: "blur",
          },
        },
        judicialLitigationHD: [],
        filePath: '',
        fileList: [],
        nowProgress: 0, // 进度
        showImport: false,
        uploading: false,
        JbcertQueueName: '',
        runTime: 0, // 初始化查询进度次数，要走10次
        errorTxt: '', // 错误提示
        JbcertQueueName: '', // 导入编号
        interval: null,
        OrderCount: 0, // 导入总数
      };
    },
    created() {
      this.dimJudicialTitleData = [{
          lablename: '出生日期',
          lableId: 'ppre_birthday'
        },
        {
          lablename: '正文',
          lableId: 'ppre_body'
        },
        {
          lablename: '受理费',
          lableId: 'ppre_caf'
        },
        {
          lablename: '案由',
          lableId: 'ppre_case_cause'
        },
        {
          lablename: '案号',
          lableId: 'ppre_caseno'
        },
        {
          lablename: '代字',
          lableId: 'ppre_caseno_kword'
        },
        {
          lablename: '文书类型',
          lableId: 'ppre_case_type'
        },
        {
          lablename: '法院',
          lableId: 'ppre_court'
        },
        {
          lablename: '法院等级',
          lableId: 'ppre_court_rank'
        },
        {
          lablename: '法院类型',
          lableId: 'ppre_court_type'
        },
        {
          lablename: '法官',
          lableId: 'ppre_judge'
        },
        {
          lablename: '判决结果',
          lableId: 'ppre_judge_result'
        },
        {
          lablename: '律师事务所',
          lableId: 'ppre_law_office'
        },
        {
          lablename: '委托律师',
          lableId: 'ppre_lawyer'
        },
        {
          lablename: '判决金额',
          lableId: 'ppre_party_fee'
        },
        {
          lablename: '诉讼地位',
          lableId: 'ppre_party_position'
        },
        {
          lablename: '胜负关系',
          lableId: 'ppre_party_result'
        },
        {
          lablename: '当事人称号',
          lableId: 'ppre_party_title'
        },
        {
          lablename: '当事人类型',
          lableId: 'ppre_party_type'
        },
        {
          lablename: '当事人名称',
          lableId: 'ppre_party_pname'
        },
        {
          lablename: '信号描述',
          lableId: 'ppre_signal_desc'
        },
        {
          lablename: '信号等级',
          lableId: 'ppre_signal_rating'
        },
        {
          lablename: '审结时间',
          lableId: 'ppre_filing_time'
        },
        {
          lablename: '标题',
          lableId: 'ppre_title'
        },
        {
          lablename: '审理状态',
          lableId: 'ppre_trial_procedures'
        },
        {
          lablename: '依据',
          lableId: 'ppre_yiju'
        },
        {
          lablename: '匹配度',
          lableId: 'ppre_match_ratio'
        }
      ]
      if (localStorage.visibleReading == "true") {
        this.visibleReading = true;
      }
      // 获取按钮权限
      this.getButtonPower()
      // 获取项目列表
      this.getResourceJoblist();
      this.getHeightTitlelist(13);
      this.getHeightTitlelist(14);
    },
    mounted() {},
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 项目摘要表格处理单元格合并
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        let that = this
        if (columnIndex === 0) {
          // 获取当前单元格的值
          const currentValue = row[column.property];
          // 获取上一行相同列的值
          const preRow = that.result.orderDetailList[rowIndex - 1];
          const preValue = preRow ? preRow[column.property] : null;
          // 如果当前值和上一行的值相同，则将当前单元格隐藏
          if (currentValue === preValue) {
            return {
              rowspan: 0,
              colspan: 0
            };
          } else {
            // 否则计算当前单元格应该跨越多少行
            let rowspan = 1;
            for (let i = rowIndex + 1; i < that.result.orderDetailList.length; i++) {
              const nextRow = that.result.orderDetailList[i];
              const nextValue = nextRow[column.property];
              if (nextValue === currentValue) {
                rowspan++;
              } else {
                break;
              }
            }
            return {
              rowspan,
              colspan: 1
            };
          }
        }
      },
      getYMDHMS(timestamp) {
        let time = new Date(timestamp)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        if (hours < 10) {
          hours = '0' + hours
        }
        if (minute < 10) {
          minute = '0' + minute
        }
        if (second < 10) {
          second = '0' + second
        }
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
      },
      // 获取项目内容列表
      getcertlist() {
        xz.getcertmenu(this.listQuery).then((res) => {
          console.log(res);
          if (res.status == "ok") {
            res.data.forEach((element) => {
              this.$set(element, "checked", false);
              element.productList.forEach((ele) => {
                this.$set(ele, "selected", false);
              });
            });
            this.tableData = res.data;
          } else {
            this.$message.error("系统出错");
            this.tableData = [];
          }
        });
      },
      // 批量查询表格多选
      handleSelectionChange(val) {
        // console.log('yyy',val)
        this.multipleTable = val;
      },
      // 选择项目名称
      proSearChange(val) {
        this.QRform.ProjectId = val;
        let obj = {};
        let that = this;
        if (!this.isNull(val)) {
          obj = that.resProjectList.find((item) => {
            return item.Projectid === val;
          });
          that.batchQuery.strProjectName = obj.StrprojectName;
          that.getNumData();
          that.getcertlist();
        } else {
          this.batchQuery.strProjectName = "";
        }
      },
      // 批量查询弹框
      batchHandle() {
        let that = this;
        let hasfrsys = false; //是否选了企业法人四要素
        this.form.productid = [];
        this.tableData.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.selected) {
              if (ele.Product == '个人工商记录查询') {
                hasfrsys = true;
              } else {
                that.form.productid.push({
                  id: ele.Id
                });
              }
            }
          });
        });
        if (hasfrsys) {
          this.$message.warning("暂不支持个人工商记录批量查询");
          return
        }
        if (that.isNull(that.form.productid)) {
          this.$message.warning("请选择闪查项目");
          return;
        } else {
          this.batchQuery.currpage = 1;
          this.getBatchTitleLists();
          this.batchQueryVisible = true;
        }
      },
      // 确定批量查询
      confirmQuery() {
        let that = this;
        let formdata = [];
        if (that.isNull(that.multipleTable)) {
          this.$message({
            type: "warning",
            message: "请选择要批量查询的数据"
          });
          return false;
        }
        // 判断身份证是否为空
        if (that.multipleTable.some((v) => that.isNull(v.StrIdCard))) {
          this.$message({
            type: "warning",
            message: "存在身份证为空的数据,请补充身份证信息",
          });
          return false;
        } else {
          if (!this.isNull(that.multipleTable)) {
            for (let i = 0; i < that.multipleTable.length; i++) {
              let elementval = that.multipleTable[i];
              formdata.push({
                name: elementval.StrUserName,
                idcard: elementval.StrIdCard,
                tel: elementval.StrMobile,
                ResumeId: elementval.ResumeId,
                Bankcard: elementval.Bankcard != undefined && elementval.Bankcard ? elementval.Bankcard : '',
                BusiType: "2",
                BusiId: that.listQuery.BusiId,
                productid: that.form.productid,
                Entcode: "",
                Entname: "",
              });
              // console.log(9999,formdata)
            }
            that.isBatchCheck = true;
            xz.batchstartcert(formdata).then((res) => {
              if (res.status == "ok") {
                this.batchQueryVisible = false;
                that.isBatchCheck = false;
                this.$message({
                  type: "success",
                  message: "查询成功"
                });
                that.$router.push({
                  path: "/backgroundCheckRecord",
                  query: {
                    BusiId: that.listQuery.BusiId,
                  },
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        }
      },
      // 分页
      batchCurrentChange(val) {
        this.batchQuery.currpage = Number(val);
        this.getBatchList();
      },
      batchSizeChange(val) {
        this.batchQuery.currpage = 1;
        this.batchQuery.perpage = Number(val);
        this.getBatchList();
      },
      // 获取表头
      getBatchTitleLists() {
        xz.getProcessColumnList(this.titleQuery.ststus).then((res) => {
          if (res.status == "ok") {
            this.tableQueryTitle = res.msg;
            this.getBatchList();
          } else {
            this.tableQueryTitle = [];
          }
        });
      },
      batchSearchHandle() {
        this.getBatchList();
      },
      // 获取查询人员列表
      getBatchList() {
        this.tableLoading = true;
        xz.getsignResumeLists(this.batchQuery).then((res) => {
          // console.log('getList', res)
          if (res.status == "ok") {
            this.tableQueryData = res.msg;
            this.batchTotal = res.totalcount;
          } else {
            this.tableQueryData = [];
            this.batchTotal = 0;
          }
          this.tableLoading = false;
        });
      },
      // 获取法院被执行人取表头" 13代表法院被执行人—高级版，14代表 法院被执行人-限高版
      getHeightTitlelist(type) {
        xz.getbairongExecutionPro(type).then((res) => {
          if (res.status == "ok") {
            if (type == "13") {
              this.heightTitleData = res.data;
            } else if (type == "14") {
              this.heightLimitTitleData = res.data;
            }
          } else {
            if (type == "13") {
              this.heightTitleData = [];
            } else if (type == "14") {
              this.heightLimitTitleData = [];
            }
          }
        });
      },
      handleClick(tab, event) {
        let that = this;
        if (this.activeName == "second") {
          this.$router.push({
            path: "/backgroundCheckRecord",
            query: {
              BusiId: that.listQuery.BusiId,
            },
          });
        } else if (this.activeName == "third") {
          this.$router.push({
            path: "/bgQRcodeList",
            query: {
              projectId: that.listQuery.BusiId,
            },
          });
        }
      },
      // 选择套餐/项目
      select(item, row) {
        let that = this;
        console.log(item);
        this.$set(item, "selected", !item.selected);
        if (!item.selected) {
          this.$set(row, "checked", false);
        } else {
          this.$set(
            row,
            "checked",
            !row.productList.some((element) => !element.selected)
          );
        }
        this.getTotalPrice();
      },
      // 计算总价
      getTotalPrice() {
        this.totalPrice = 0;
        this.needPhone = false;
        this.needBank = false;
        this.needIdcard = false;
        this.needEnt = false;
        this.needEntName = false;
        this.tableData.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.selected) {
              this.totalPrice = this.totalPrice + ele.Price;
              //HasEntcode 0不需要输入 1需要输入
              if (ele.IsAuthorize == "1" || ele.HasTel == "1") {
                this.needPhone = true;
              }
              if (ele.HasIdcard == "1") {
                this.needIdcard = true;
              }
              if (ele.Hasbank == "1") {
                this.needBank = true;
              }
              if (ele.HasEntcode == "1") {
                this.needEnt = true;
              }
              if (ele.HasEntname == "1") {
                this.needEntName = true;
              }
            }
          });
        });
        // console.log('44',this.needPhone,this.needBank,this.needEnt,this.needEntName,this.needIdcard)
      },
      // 身份证校验
      checkIdcard(val) {
        if (val.length != 18) {
          return false;
        } else {
          const idcode = val;
          const weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          const check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          const code = idcode + "";
          const last = idcode[17].toUpperCase(); // 最后一个
          const seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          const arr = seventeen.split("");
          const len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          return last === last_no && format == true;
        }
      },
      // 提交查询
      submitForm(formName) {
        let that = this;
        this.form.productid = [];
        this.tableData.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.selected) {
              that.form.productid.push({
                id: ele.Id
              });
            }
          });
        });
        this.form.BusiId = this.listQuery.BusiId;
        if (this.form.productid.length == 0) {
          this.$message.warning("请选择项目");
        } else {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.isBtnLoading = true;
              (that.Id = ""),
              xz.startcert(that.form).then((res) => {
                if (res.status == "ok") {
                  this.$message.success("查询成功！");
                  that.hasCheck = true;
                  that.Id = res.data;
                  if (res.flagIsAuthorize == true) {
                    that.flagIsAuthorize = true;
                  } else {
                    that.flagIsAuthorize = false;
                    this.getcertorderdetail();
                  }
                  this.getNumData();
                } else {
                  this.$message.warning(res.msg);
                }
              });
              this.isBtnLoading = false;
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        }
      },
      getcertorderdetail() {
        let that = this;
        xz.getcertorderdetail(this.Id).then((res) => {
          this.judicialLitigationHD = []
          this.judicialLitigation = [];
          this.personalAdvanced = [];
          this.creditRisks = [];
          this.riskWarningData = []
          this.litigationRisk = []
          that.caseProcessData = []; // 案件流程维度
          that.dimJudicialData = []; // 裁判文书维度
          that.courtDimData = []; // 法院公告维度
          that.openDimData = []; // 开庭公告维度
          that.exposureTableData = []; // 曝光台
          that.dishonestInfoData = []; // 失信信息
          that.overdueRiskData = [];
          that.educInfoData = [];
          if (res.status == "ok") {
            this.result = res.data;
            let copyData = JSON.parse(JSON.stringify(res.data.orderDetailList)) //拷贝
            if (!that.isNull(copyData)) {
              let copy01 = []
              // 排除掉岗位未修改时的数据(异常状态下未修改的不用走终止接口)
              copy01 = copyData.filter(item => {
                return (item.IsRiskResult != 0) && (item.Progress == 2)
              });
              for (let i = 0; i < copy01.length; i++) {
                for (let j = i + 1; j < copy01.length; j++) {
                  if (copy01[i].Category === copy01[j].Category) {
                    copy01.splice(j, 1);
                    j--
                  }
                };
              }
              that.riskWarningData = copy01
            } else {
              that.riskWarningData = []
            }
            if (res.data.order.Progress == 4) {
              this.$message.warning("候选人还未签署电子签");
            } else {
              this.flagIsAuthorize = false;
              this.hasResult = true;
              res.data.orderDetailList.forEach((element) => {
                if (!that.isNull(element.ThirdPartyReturn)) {
                  that.$set(element, "ThirdPartyReturn3", JSON.parse(element.ThirdPartyReturn));
                } else {
                  that.$set(element, "ThirdPartyReturn3", '');
                }
                if (element.Category == '诉讼风险') {
                  this.litigationRisk.push(element);
                }
                //身份信息验证
                if (element.ProductId == "f11ea4e6-195c-4e99-9b97-44347cd61b0c") {
                  this.identityReport = [{
                      name: "身份证号码",
                      result: this.encryption(res.data.order.SurveyIdcard),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "姓名",
                      result: res.data.order.SurveyName,
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                  ];
                } else if (element.ProductId == 'f21ea4e6-195c-4e99-9b97-44347cd61b0c') {
                  this.telReport = [{
                      name: "身份证号码",
                      result: this.encryption(res.data.order.SurveyIdcard),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "姓名",
                      result: res.data.order.SurveyName,
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "手机号码",
                      result: this.encryption(res.data.order.SurveyTel),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                  ];
                } else if (element.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c') {
                  this.bankReport = [{
                      name: "身份证号码",
                      result: this.encryption(res.data.order.SurveyIdcard),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "姓名",
                      result: res.data.order.SurveyName,
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "手机号码",
                      result: this.encryption(res.data.order.SurveyTel),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                    {
                      name: "银行卡",
                      result: this.encryption(res.data.order.Bankcard),
                      truth: element.IsRiskResult,
                      remark: "",
                    },
                  ];
                } else if (element.ProductId == "f32ea4e6-195c-4e99-9b97-44347cd61b8c") {
                  if (!that.isNull(element.ThirdPartyReturn3)) {
                    let thirddata = element.ThirdPartyReturn3.data
                    let thirddatares = thirddata.result
                    if (thirddatares && !that.isNull(thirddatares) && JSON.stringify(thirddatares) != '{}') {
                      that.educInfoData = [{
                          name: '学校名称',
                          result: thirddatares.SL ? thirddatares.SL : '',
                          resultType: 'SL',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '专业',
                          result: thirddatares.MJ ? thirddatares.MJ : '',
                          resultType: 'MJ',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '入学日期',
                          result: thirddatares.RD ? thirddatares.RD : '',
                          resultType: 'RD',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '毕业日期',
                          result: thirddatares.BD ? thirddatares.BD : '',
                          resultType: 'BD',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '985学校核验',
                          result: thirddatares.UCA == 1 ? '是' : '否',
                          resultType: 'UCA',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '211学校核验',
                          result: thirddatares.UCB == 1 ? '是' : '否',
                          resultType: 'UCB',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '双一流学校核验',
                          result: thirddatares.UCC == 1 ? '是' : '否',
                          resultType: 'UCC',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '学习形式',
                          result: !that.isNullEdu(thirddatares.FC) ? thirddatares.FC : '',
                          resultType: 'FC',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '学习层次',
                          result: !that.isNullEdu(thirddatares.LC) ? thirddatares.LC : '',
                          resultType: 'LC',
                          truth: element.IsRiskResult,
                          remark: ''
                        },
                        {
                          name: '毕业状态',
                          result: thirddatares.ST ? thirddatares.ST : '',
                          resultType: 'ST',
                          truth: element.IsRiskResult,
                          remark: ''
                        }
                      ]
                      // 排除掉为空的数据
                      that.educInfoData = that.educInfoData.filter(function (item, index, array) {
                        return !that.isNullEdu(item.result);
                      });
                    } else {
                      that.educInfoData = []
                    }
                  } else {
                    that.educInfoData = []
                  }
                } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b4c') {
                  if (!that.isNull(element.ThirdPartyReturn3)) {
                    let thirddata3 = element.ThirdPartyReturn3.DATA
                    if (thirddata3 && !that.isNull(thirddata3) && JSON.stringify(thirddata3) != '{}') {
                      that.overdueRiskData = [{
                          name: '最近一次逾期距今天数',
                          result: thirddata3.D942 && thirddata3.D942 != 'none' ? thirddata3.D942 : thirddata3.D942 == 'none' ? '0' : '',
                          resultType: 'D942'
                        },
                        {
                          name: '最大逾期天数距今天数',
                          result: thirddata3.D945 && thirddata3.D945 != 'none' ? thirddata3.D945 : thirddata3.D945 == 'none' ? '0' : '',
                          resultType: 'D945'
                        },
                        {
                          name: '逾期次数',
                          result: thirddata3.D177 && thirddata3.D177 != 'none' ? thirddata3.D177 : thirddata3.D177 == 'none' ? '0' : '',
                          resultType: 'D177'
                        },
                        {
                          name: '逾期机构数',
                          result: thirddata3.D939 && thirddata3.D939 != 'none' ? thirddata3.D939 : thirddata3.D939 == 'none' ? '0' : '',
                          resultType: 'D939'
                        },
                        {
                          name: '逾期总金额',
                          result: thirddata3.D181 && thirddata3.D181 != 'none' ? thirddata3.D181 : thirddata3.D181 == 'none' ? '0' : '',
                          resultType: 'D181'
                        },
                        {
                          name: '逾期最大金额',
                          result: thirddata3.D185 && thirddata3.D185 != 'none' ? thirddata3.D185 : thirddata3.D185 == 'none' ? '0' : '',
                          resultType: 'D185'
                        },
                        {
                          name: '最大一次逾期距今天数',
                          result: thirddata3.D940 && thirddata3.D940 != 'none' ? thirddata3.D940 : thirddata3.D940 == 'none' ? '0' : '',
                          resultType: 'D940'
                        },
                        {
                          name: '最近一次逾期金额',
                          result: thirddata3.D941 && thirddata3.D941 != 'none' ? thirddata3.D941 : thirddata3.D941 == 'none' ? '0' : '',
                          resultType: 'D941'
                        },
                        {
                          name: '最近一次逾期机构类型',
                          result: thirddata3.D943 && thirddata3.D943 != 'none' ? thirddata3.D943 : thirddata3.D943 == 'none' ? '0' : '',
                          resultType: 'D943'
                        },
                        {
                          name: '最大逾期天数',
                          result: thirddata3.D944 && thirddata3.D944 != 'none' ? thirddata3.D944 : thirddata3.D944 == 'none' ? '0' : '',
                          resultType: 'D944'
                        }
                      ]
                    } else {
                      that.overdueRiskData = []
                    }
                  } else {
                    that.overdueRiskData = []
                  }
                } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b91-44347cd62b9c') {
                  if (!that.isNull(element.ThirdPartyReturnSet)) {
                    let info2 = JSON.parse(element.ThirdPartyReturnSet);
                    that.$set(element, "returnSetList2", info2);
                  }
                } else if (element.ProductId == 'F32ea4e6-195c-4e99-9b97-44347cd61b0c') {
                  if (!that.isNull(element.ThirdPartyReturnSet)) {
                    let info1 = JSON.parse(element.ThirdPartyReturnSet);
                    that.$set(element, "returnSetList1", info1);
                  }
                  // console.log(JSON.parse(element.ThirdPartyReturnSet))
                } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b9c') {
                  if (
                    element.ThirdPartyReturn != undefined &&
                    element.ThirdPartyReturn
                  ) {
                    if (element.ThirdParty == '朴道') { //朴道
                      try {
                        let info = JSON.parse(element.ThirdPartyReturn);
                        let a = JSON.parse(info.data).ppre_execut;
                        let b = JSON.parse(info.data).ppre_case_flow;
                        let c = JSON.parse(info.data).ppre_judgment;
                        let d = JSON.parse(info.data).ppre_court_notice;
                        let e = JSON.parse(info.data).ppre_session;
                        let f = JSON.parse(info.data).ppre_exposure;
                        let g = JSON.parse(info.data).ppre_dishonesty;
                        if (!this.isNull(a)) {
                          that.judicialLitigation = a; // 执行公告维度
                        }
                        if (!this.isNull(b)) {
                          that.caseProcessData = b; // 案件流程维度
                        }
                        if (!this.isNull(c)) {
                          that.dimJudicialData = c; // 裁判文书维度
                        }
                        if (!this.isNull(d)) {
                          that.courtDimData = d; // 法院公告维度
                        }
                        if (!this.isNull(e)) {
                          that.openDimData = e; // 开庭公告维度
                        }
                        if (!this.isNull(f)) {
                          that.exposureTableData = f; // 曝光台
                        }
                        if (!this.isNull(g)) {
                          that.dishonestInfoData = g; // 失信信息
                        }
                      } catch (e) {
                        console.log(e)
                      }
                    } else if (element.ThirdParty == '华道') { //华道
                      try {
                        let a = JSON.parse(element.ThirdPartyReturn);
                        this.judicialLitigationHD = a.ALLLIST;
                      } catch (e) {
                        console.log(e)
                      }
                    }
                  }
                } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd62b9c') {
                  if (
                    element.ThirdPartyReturn != undefined &&
                    element.ThirdPartyReturn
                  ) {
                    let info = JSON.parse(element.ThirdPartyReturn);
                    // console.log("666", info.CourtDetailPro);
                    if (!that.isNull(info.CourtDetailPro.entryList)) {
                      that.personalAdvanced = info.CourtDetailPro.entryList;
                    }
                  }
                } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b1c') {
                  if (
                    element.ThirdPartyReturnSet != undefined &&
                    element.ThirdPartyReturnSet
                  ) {
                    this.creditRisks = JSON.parse(element.ThirdPartyReturnSet);
                  }
                }
              })
              if (!that.isNull(that.litigationRisk)) { //判断司法诉讼是否存在有风险的
                let obj1 = that.litigationRisk.filter(item => item.IsRiskResult != '0');
                if (obj1 && !that.isNull(obj1)) {
                  // 存在
                  that.isHasRiskData = true
                } else {
                  // 不存在
                  that.isHasRiskData = false
                }
              }
            }
          } else {
            this.$message.error("结果获取失败，请从闪查记录页面查看结果！");
            this.result = {};
          }
        });
      },
      // 获取有权限的项目列表和岗位列表
      getResourceJoblist() {
        let data = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1
        }
        xz.getProjectLists(data).then(
          (res) => {
            // console.log('项目名称列表', res)
            if (res.status == "ok") {
              // console.log(99,res)
              this.resProjectList = res.msg;
              // 项目列表去重
              let obj = {};
              let peon = this.resProjectList.reduce((cur, next) => {
                obj[next.StrprojectName] ?
                  "" :
                  (obj[next.StrprojectName] = true && cur.push(next));
                return cur;
              }, []); //设置cur默认类型为数组，并且初始值为空的数组
              this.resProjectList = peon;
              this.listQuery.BusiId = this.resProjectList[0].Projectid;
              this.QRform.ProjectId = this.resProjectList[0].Projectid;
              this.getcertlist();
              this.getNumData();
            }
          }
        );
      },
      // 获取工作台 次数
      getNumData() {
        let that = this;
        let query = {
          BusiId: this.listQuery.BusiId,
          BusiType: "2",
        };
        xz.getworkingdisplaystation(query).then((res) => {
          // console.log('项目名称列表', res)
          if (res.status == "ok") {
            if (!this.isNull(res.data)) {
              that.remainingTimes = res.data.Amount;
              that.queryTimes = res.data.IssuedReportNum;
              that.AmountSpent = res.data.AmountSpent;
            } else {
              that.remainingTimes = 0;
              that.queryTimes = 0;
            }
          } else {
            that.remainingTimes = 0;
            that.queryTimes = 0;
          }
        });
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o === "" ||
          o == "null" ||
          o === [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      isNullEdu(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == 'undefined' ||
          (o + '').indexOf('undefined') > -1 ||
          o == null ||
          o === '' ||
          o == 'null' ||
          o === [] ||
          o == 'NaN'
        )
      },
      // 重置
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 时间戳转日期时间
      getDate(val) {
        if (val) {
          const date = new Date(val); // 根据时间戳创建Date对象
          const year = date.getFullYear(); // 获取年份
          const month = date.getMonth() + 1; // 获取月份，需要加1
          const day = date.getDate(); // 获取日期
          const formattedDate = `${year}-${month}-${day}`; // 拼接成格式化后的日期字符串
          console.log(formattedDate);
          return formattedDate;
        } else {
          return "";
        }
      },
      // 勾选产品
      changeCheck(row) {
        console.log(row);
        row.productList.forEach((element) => {
          this.$set(element, "selected", row.checked);
        });
        this.getTotalPrice();
      },
      // 全选
      changeCheckAll(val) {
        this.tableData.forEach((element) => {
          this.$set(element, "checked", this.checkedAll);
          element.productList.forEach((ele) => {
            this.$set(ele, "selected", this.checkedAll);
          });
        });
        this.getTotalPrice();
      },
      // 加密处理
      encryption(val) {
        if (val.length == 11) {
          const r1 = val.slice(0, 3);
          const r2 = val.slice(val.length - 4, val.length);
          return r1 + "****" + r2;
        } else {
          const r1 = val.slice(0, 4);
          const r2 = val.slice(val.length - 4, val.length);
          return r1 + "**********" + r2;
        }
      },
      handleExport() {
        this.expvivw = true;
        // this.$nextTick(() => {
        //   this.getSmall()
        // })
        const name =
          "闪查报告-" + this.result.order.SurveyName + "-" + this.result.order.Id;
        setTimeout(() => {
          let lableList1 = document.getElementsByClassName('small_item');
          let logo = document.getElementById("logo"); //放在页眉的图标
          downloadPDF(name, document.querySelector('#pdf_details'), lableList1, logo);
        }, 100);
        setTimeout(() => {
          this.expvivw = false;
        }, 200);
        this.visibleReport = false;
      },
      //pdf多页分割处理
      getSmall() {
        let dom = document.getElementsByClassName("small_item");
        for (var i = 0; i < dom.length; i++) {
          // console.log(i)
          let h = 1300;
          console.log('top', dom[i].offsetTop)
          if (
            i != 0 && this.offset(dom[i]).top % h > this.offset(dom[i + 1]).top % h &&
            h - (this.offset(dom[i]).top % h) < dom[i].offsetHeight
          ) {
            dom[i - 1].style.marginBottom =
              (h + 80) - (this.offset(dom[i]).top % h) + "Px";
          }
        }
      },
      offset(element) {
        var pos = {
          left: 0,
          top: 0
        };
        var parents = element.offsetParent;
        pos.left += element.offsetLeft;
        pos.top += element.offsetTop;
        while (parents && !/html|body/i.test(parents.tagName)) {
          pos.left += parents.offsetLeft;
          pos.top += parents.offsetTop;
          parents = parents.offsetParent;
          console.log('offsetTop', parents.offsetTop)
        }
        console.log('pos', pos)
        return pos;
      },
      closeRead() {
        window.localStorage.setItem("visibleReading", false);
        this.visibleReading = false;
      },
      // 判断在职天数是否是负数
      isMinus(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          Number(o) < 0
        );
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
      editPerson(item, index) {
        this.info = {
          StrUserName: item.StrUserName,
          // StrMobile:item.StrMobile,
          StrIdCard: item.StrIdCard,
          index: index
        }
        this.visibleEditPerson = true;
        // tableQueryData
      },
      addIdcard() {
        if (this.info.StrIdCard && this.info.StrUserName) {
          this.$set(this.tableQueryData[this.info.index], 'StrIdCard', this.info.StrIdCard)
          this.$set(this.tableQueryData[this.info.index], 'StrUserName', this.info.StrUserName)
          this.$set(this.tableQueryData[this.info.index], 'Bankcard', this.info.Bankcard)
          this.visibleEditPerson = false;
        }
      },
      //创建二维码
      createQRcode() {
        let ids = [];
        this.tableData.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.selected) {
              ids.push(ele.Id);
            }
          });
        });
        this.QRform.BusiIds = ids.toString();
        if (ids.length == 0) {
          this.$message.warning("请选择项目");
        } else {
          this.showCreateQRcode = true;
        }
      },
      //确认创建二维码
      confirmCreateQRcode() {
        this.$refs.QRform.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.CreateQrCode(this.QRform).then(res => {
              if (res.status == 'ok') {
                this.showCreateQRcode = false;
                this.isBtnLoading = false;
                this.QRcodeCreateTime = moment().format('YYYY-MM-DD  h:mm:ss')
                this.QRCodeSrc = res.data;
                this.showQRcode = true;
              } else {
                this.$message.error('二维生成失败')
                this.showCreateQRcode = false;
                this.isBtnLoading = false;
              }
            })
          }
        })
        // this.QRcodeCreateTime = moment().format('YYYY-MM-DD  h:mm:ss')
        // this.showCreateQRcode = false;
        // this.QRCodeSrc = 'QRCoder/qrcode20240219143907.jpg';
        // this.showQRcode = true;
      },
      batchImpHandle() {
        let that = this;
        let hasfrsys = false; //是否选了企业法人四要素
        this.form.productid = [];
        this.tableData.forEach((element) => {
          element.productList.forEach((ele) => {
            if (ele.selected) {
              if (ele.Product == '个人工商记录查询') {
                hasfrsys = true;
              } else {
                that.form.productid.push({
                  id: ele.Id
                });
              }
            }
          });
        });
        if (hasfrsys) {
          this.$message.warning("暂不支持个人工商记录批量查询");
          return
        }
        if (that.isNull(that.form.productid)) {
          this.$message.warning("请选择闪查项目");
          return;
        } else {
          this.fileList = [];
          this.nowProgress = null;
          this.OrderCount = '';
          this.errorTxt = '';
          this.filePath = '';
          this.showImport = true;
        }
      },
      // 下载模板
      downLoadHandle() {
        let d = {
          BusiType: '2',
          BusiId: this.listQuery.BusiId,
          productid: this.form.productid
        }
        xz.getImportquerytemplate(d).then(res => {
          if (res.status == 'ok') {
            var d = res.data
            d = d.replace('"', '').replace('"', '')
            var path = 'https://emp.joball.net/cloudexcel/' + d
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click()
          } else {
            this.$message.error('下载模板失败')
          }
        })
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.filePath = res;
          } else {
            this.filePath = '';
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多导入 1 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.filePath = '';
      },
      confirmImport() {
        let d = {
          BusiType: '2',
          BusiId: this.listQuery.BusiId,
          productid: this.form.productid,
          url: this.filePath,
        }
        this.uploading = true
        xz.certFun(d, 'batchImportquery1').then(res => {
          if (res.status == 'ok') {
            this.$message.success('提交成功')
            this.OrderCount = res.data.OrderCount
            this.JbcertQueueName = res.data.JbcertQueueName
            this.batchImportQueryConsumer()
            this.uploading = false
          } else {
            this.uploading = false
            this.errorTxt = res.msg
            this.$message.error('导入失败')
          }
        })
      },
      batchImportQueryConsumer() {
        this.runTime++
        xz.certFun(this.JbcertQueueName, 'batchImportQueryConsumer').then(res => {})
        this.getProgress()
      },
      // 获取导入进度
      getProgress() {
        clearInterval(this.interval)
        xz.certFun(this.JbcertQueueName, 'batchImportQueryQueueLen').then(res => {
          if (res.status == 'ok') {
            const residue = this.OrderCount - res.data
            this.nowProgress = (residue / this.OrderCount * 100).toFixed(0)
            console.log(res.data, residue / this.OrderCount, this.nowProgress)
            if (this.nowProgress == 100) {
              this.$message.success('导入完成')
            }
            if (res.data > 0) {
              this.interval = setInterval(this.getProgress, 10000)
            }
          }
        })
      },
      // 清除定时器的代码
      clear() {
        clearInterval(this.interval)
        this.interval = null
      },
    },
  };
</script>
<style scoped lang="scss">
  .lh20 {
    line-height: 20px;
    margin: 0;
  }

  #logo {
    display: none;
    width: 175px;
    height: 57px;
  }

  .bg_des_box {
    display: flex;
    align-items: center;
    border: 1px solid #dfe6ec;
    border-bottom: none;
    font-size: 14px;
    color: #333;
    background-color: rgba(221, 221, 221, .7);
  }

  .bg_des_left {
    width: 180px;
    text-align: left;
    padding: 10px 0;
    // color:#606266;
    box-sizing: border-box;
  }

  .bg_des_right {
    flex: 1;
    text-align: left;
    padding: 10px;
    line-height: 20px;
    box-sizing: border-box;
    border-left: 1px solid #ddd;
  }

  .pic_txt {
    margin: 0;
    line-height: 20px;
  }

  .bg_result_box {
    width: 1001px;
    // background-color: #ddd;
  }

  .bg_result_box.bg_result_box00 {
    width: auto;
  }

  .bg_result_box00 .bg_result_item {
    width: 100%;
    box-sizing: border-box;
  }

  .bg_result_item {
    color: #606266;
    background-color: #FFFFFF;
    font-size: 14px;
    border-collapse: collapse;
    display: table;
  }

  .bg_result_left {
    font-weight: 500;
    color: #000;
    width: 181px;
    text-align: left;
  }

  .bg_result_right {
    width: 820px;
    text-align: left;
  }

  .bg_result_cell {
    display: table-cell;
    border: 1px solid #e6ebf5;
    padding: 10px;
    box-sizing: border-box;
    border-collapse: collapse;
    line-height: 1.5;
  }

  .bg_result_item02 .bg_result_cell {
    border-top: none;
  }

  .category_title {
    width: 1001px;
    color: #606266;
    text-align: left;
    padding-left: 10px;
    // font-weight: bold;
    // color: #fff;
    background: rgba(25, 189, 146, .4);
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    box-sizing: border-box;
    // border: 1px solid #dfe6ec;
  }

  .category_title00.category_title {
    width: auto;
  }

  .bg_widthauto.bg_result_right {
    width: calc(100% - 181px);
  }

  .mb24 {
    margin-bottom: 24px;
  }

  .w1000 {
    width: 1000px;
    box-sizing: border-box;
  }

  .w1000_des {
    width: 1000px;
    padding: 15px 15px 0px 15px;
  }

  .c_border {
    border: 1px solid #dfe6ec;
    padding: 12px 10px;
  }

  .note_danger_txt {
    color: #000000a6;
    font-size: 14px;
  }

  .res_icon_right {
    font-size: 24px;
    color: #19bd92;
  }

  .res_icon_error {
    font-size: 24px;
    color: #F56C6C;
  }

  .title_note_box {
    color: #666;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .dia_search_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .dia_search_box .dia_search_item {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .dia_search_item>p {
    margin-right: 4px;
  }

  .ftabs .l_txt {
    word-wrap: break-word;
  }

  .dash_sel_box {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px 5px 16px 0;
  }

  .dash_sel_box .flname {
    font-size: 20px;
    margin-right: 4px;
    width: 100px;
  }

  .dashboard {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    width: calc(98% + 42px);
  }

  .dashboard_item {
    width: 32%;
    min-width: 290px;
    background: #fff;
    position: relative;
    margin-bottom: 12px;
  }

  .dashboard .dashboard_item:nth-child(2) {
    margin: 0 2% 10px;
  }

  .dashboard_item_title {
    font-size: 20px;
    text-align: center;
    padding: 16px 0;
  }

  .dashboard_item_content {
    font-size: 28px;
    font-weight: bold;
    margin-left: 30px;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .th {
    font-size: 14px;
    color: #000000a6;
    font-weight: 500;
  }

  .checkBox {
    flex-wrap: wrap;
  }

  .checkItem {
    background: #f0f0f0;
    color: #495060;
    height: 34px;
    line-height: 34px;
    width: calc(33% - 20px);
    /* max-width: 300px; */
    margin-right: 10px;
    font-size: 13px;
  }

  .mt {
    margin-top: 10px;
  }

  .icon {
    width: 16px;
    height: 16px;
    margin: 0 10px;
  }

  .selectedbc {
    background: #19bd92;
    color: #fff;
  }

  .packageBox {
    display: flex;
  }

  .packageItem {
    height: 236px;
    width: 300px;
    margin-right: 15px;
    background: #f7f7f7;
  }

  .packageTitle {
    width: 100%;
    text-align: center;
    background-color: #eee;
    font-weight: 700;
    height: 36px;
    line-height: 36px;
    margin-bottom: 10px;
  }

  .dd {
    line-height: 30px;
    height: 30px;
    padding-left: 10px;
  }

  .selectedTitle {
    background: #19bd92;
    color: #fff;
  }

  .selectedBox {
    border: 1px solid #19bd92;
    position: relative;
    overflow: hidden;

    &::before {
      content: " ";
      position: absolute;
      width: 4px;
      height: 100%;
      top: -100%;
      left: 0;
      background-image: linear-gradient(0deg, transparent, #74efff, transparent);
      animation: two 4s linear infinite;
    }

    &::after {
      content: " ";
      position: absolute;
      width: 4px;
      height: 100%;
      bottom: -100%;
      right: 0;
      background-image: linear-gradient(360deg,
          transparent,
          #74efff,
          transparent);
      animation: four 4s linear 2s infinite;
    }

    i {
      position: absolute;
      display: inline-block;
      height: 4px;
      width: 100%;
    }

    .bottom {
      bottom: 0;
      left: -100%;
      background-image: linear-gradient(270deg,
          transparent,
          #74efff,
          transparent);
      animation: one 4s linear 1s infinite;
    }

    .top {
      top: 0;
      right: -100%;
      background-image: linear-gradient(270deg,
          transparent,
          #74efff,
          transparent);
      animation: three 4s linear 3s infinite;
    }
  }

  @keyframes one {
    0% {
      left: -100%;
    }

    50%,
    100% {
      left: 100%;
    }
  }

  @keyframes two {
    0% {
      top: -100%;
    }

    50%,
    100% {
      top: 100%;
    }
  }

  @keyframes three {
    0% {
      right: -100%;
    }

    50%,
    100% {
      right: 100%;
    }
  }

  @keyframes four {
    0% {
      bottom: -100%;
    }

    50%,
    100% {
      bottom: 100%;
    }
  }

  .ftabs_title {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px dashed #ddd;
    color: rgba(0, 0, 0, 0.65);
    font-size: 15px;
    padding-left: 24px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .proName {
    font-weight: 700;
    font-size: 14px;
    margin-left: 15px;
  }

  .contentTips {
    font-size: 14px;
    margin-top: 10px;
    margin-left: 15px;
  }

  .price {
    color: #f60;
    font-size: 24px;
    font-weight: 400;
    margin-right: 15px;
  }

  .logo img {
    width: 175px;
    margin-top: 20px;
  }

  .resultTitle {
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    font-weight: 600;
    margin: 24px 0;
    width: 1000px;
  }

  .tableTitle {
    width: 1001px;
    // margin-left: 24px;
    color: #fff;
    background: #19bd92;
    text-align: center;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }

  .result_report_box {
    width: 100%;
    background: #fff;
    opacity: 0;
  }

  .result_report {
    width: 1001px;
    padding: 10px 100px 30px;
    margin: 0 auto;
    position: relative;
  }

  .page_backgroundCheck {
    min-height: calc(100vh - 84px);
    background: #f3f3f3;
    padding: 12px 16px;
  }

  .diaTitle {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .weight {
    font-weight: bolder;
  }

  .note_txt {
    padding-right: 10px;
  }

  .note_txt p {
    line-height: 24px;
  }

  .readDialog {
    height: 400px;
    overflow-y: scroll;
    position: relative;
    padding: 20px 0 0 20px;
    font-size: 13px;
  }

  .dialogFoot {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #f3f3f3;
  }

  .tips {
    padding-left: 15px;
  }

  .tips p {
    font-size: 13px;
  }

  .flagIsAuthorize {
    padding-left: 12px;
    margin-bottom: 12px;
  }

  .rpTirle {
    font-size: 48px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }

  .rpContent {
    text-align: center;
    width: 100%;
    margin: 24px 0;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dot {
    border-radius: 100%;
    background: #19bd92;
  }

  .dot1 {
    width: 8px;
    height: 8px;
  }

  .dot2 {
    width: 12px;
    height: 12px;
    margin: 0 8px;
  }

  .dot3 {
    width: 16px;
    height: 16px;
  }

  .statement {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 18px;
  }

  .statementContent {
    text-indent: 2em;
    line-height: 32px;
    font-size: 18px;
  }

  .warningIcon {
    padding-right: 15px;
    font-size: 18px;
  }

  .QRcodeCreateTime {
    font-size: 18px;
    text-align: center;
  }

  .errorTxt {
    color: red;
    margin-top: 10px;
    width: 560px;
  }
  .progress{
    display: flex;
    height: 24px;
    align-items: center;
  }
</style>

<style>
  /* .el-tooltip .item{
    widows: 100%;
} */
  .up_dialog .el-table .el-table__cell {
    padding: 2px 0;
  }

  .page_backgroundCheck .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: #fff;
  }

  .page_backgroundCheck .el-descriptions-item__label {
    font-weight: 700 !important;
    color: #000;
    width: 180px;
  }

  .page_backgroundCheck .el-descriptions-item__content {
    width: 400px;
  }

  .reading .el-dialog__body {
    padding: 5px;
  }

  .reading .el-dialog__header {
    padding: 0;
  }

  .personalAdvanced .el-descriptions-item__label.is-bordered-label {
    width: 180px !important;
    line-height: 20px !important;
  }

  .personalAdvanced .el-descriptions-item__content {
    width: 320px !important;
    line-height: 20px !important;
  }
</style>